import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from '../../Interceptors/axiosInstance';
import Cookies from 'js-cookie';

const headers = {
  'accept': '*/*',
  'Authorization': `Bearer ${Cookies.get('accessToken')}`,
};

const logheaders = {
  'accept': '*/*',
  'Content-Type': 'application/json',
};

export const loginUser = createAsyncThunk(
  "auth/login",
  async ({ username, password, keepLogged }, { rejectWithValue }) => {
    try {
      const loginData = {
        userName: username.trim(),
        password: password.trim(),
        keepLogged,
      };
      const response = await axiosInstance.post("/auth/login", loginData, {logheaders});

      const { result } = response.data ?? {};

      Cookies.set("accessToken", result.accessToken, { expires: 1 });
      Cookies.set("refreshToken", result.refreshToken, { expires: 7 });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const logoutUser = createAsyncThunk("auth/logout", async () => {
    try {
      await axiosInstance.post("/auth/logout", {headers});
      Cookies.remove("accessToken");
      Cookies.remove("refreshToken");
    } catch (error) {
     console.log(error);
    }
  });
